import React, { createContext, useState, useEffect } from 'react';
import { api } from '../api';

export const AppContext = createContext();

export function AppProvider({ children }) {
  const [refreshKey, setRefreshKey] = useState(0);
  const [currentUser, setCurrentUser] = useState(null);
  const [authLoading, setAuthLoading] = useState(true);

  const refresh = () => setRefreshKey((k) => k + 1);

  useEffect(() => {
    const token = localStorage.getItem('auth_token');
    if (!token) {
      setAuthLoading(false);
      return;
    }
    api.getMe()
      .then((user) => { setCurrentUser(user); setAuthLoading(false); })
      .catch(() => {
        localStorage.removeItem('auth_token');
        setAuthLoading(false);
      });
  }, []);

  const login = (tokenData) => {
    localStorage.setItem('auth_token', tokenData.access_token);
    setCurrentUser({
      id: tokenData.user_id,
      email: tokenData.email,
      nickname: tokenData.nickname,
    });
  };

  const logout = () => {
    localStorage.removeItem('auth_token');
    setCurrentUser(null);
  };

  const updateUser = (updates) => {
    setCurrentUser((u) => ({ ...u, ...updates }));
  };

  return (
    <AppContext.Provider value={{ refreshKey, refresh, currentUser, authLoading, login, logout, updateUser }}>
      {children}
    </AppContext.Provider>
  );
}
